module.exports = __webpack_public_path__ + "static/media/gallery-ums-mockup.ffe5be06.jpg";